import styled from 'styled-components';

export const StyledBar = styled.div`
    top: 17px;
    left: -50%;
    right: 50%;
    position: absolute;
    border-width: 3px;
    border-style: solid;
    border-color: ${props => props.borderColor};
`;
